import { Box, styled } from "@mui/material";
import theme from "../../utils/theme";

const AccountBarStyle = styled(Box)(() => ({
  paddingTop: theme.spacing(3),
  ".account-bar-content": {
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: theme.spacing(2),
    [theme.breakpoints.down("xs")]: {
      justifyContent: "space-between",
    },
  },
  ".account-bar-identity": {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    minWidth: 0,
    [theme.breakpoints.down("xs")]: {
      alignItems: "flex-start",
    },
  },
  ".account-bar-label": {
    color: theme.palette.secondary.main,
    lineHeight: "18px",
  },
  ".account-bar-account": {
    maxWidth: "100%",
    color: theme.palette.secondary.dark,
  },
  ".account-bar-logout-button": {
    flexShrink: 0,
    height: "40px",
    padding: `0 ${theme.spacing(2.5)}`,
    borderRadius: "50px",
    borderColor: theme.palette.secondary.dark,
    color: theme.palette.secondary.dark,
    textTransform: "none",
    fontFamily: "SF UI Display Medium",
    fontSize: "15px",
    "&:hover": {
      borderColor: theme.palette.secondary.dark,
      backgroundColor: theme.palette.secondary.dark,
      color: theme.palette.color1.main,
    },
  },
}));

export const LogoutDialogStyle = styled(Box)(() => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  padding: theme.spacing(5, 4, 4),
  [theme.breakpoints.down("xxs")]: {
    padding: theme.spacing(4, 3, 3),
  },
  ".logout-dialog-icon": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "56px",
    height: "56px",
    marginBottom: theme.spacing(2),
    borderRadius: "50%",
    backgroundColor: theme.palette.color13.main,
    color: theme.palette.secondary.dark,
  },
  ".logout-dialog-text": {
    marginTop: theme.spacing(1),
    color: theme.palette.secondary.main,
  },
  ".logout-dialog-actions": {
    display: "flex",
    gap: theme.spacing(1.5),
    width: "100%",
    marginTop: theme.spacing(4),
    [theme.breakpoints.down("xxs")]: {
      flexDirection: "column-reverse",
    },
  },
}));

export default AccountBarStyle;
